import { getCdnUrl } from 'owa-config';
import loc from 'owa-localize';
import {
    themeImageAriaLabel1,
    themeImageAriaLabel2,
    themeImageAriaLabel3,
    themeImageAriaLabel4,
    themeImageAriaLabel5,
    themeImageAriaLabel6,
    themeImageAriaLabel7,
    themeImageAriaLabel8,
    themeImageAriaLabel9,
    themeImageAriaLabel10,
} from './themeImages.locstring.json';
export const DEFAULT_PALETTEID: number = 9;

export const themeImageMap = new Map<number, string>([
    [0, 'background_001.png'],
    [1, 'background_002.png'],
    [2, 'background_003.png'],
    [3, 'background_004.png'],
    [4, 'background_005.png'],
    [5, 'background_006.png'],
    [6, 'background_007.png'],
    [7, 'background_009.png'],
    [8, 'background_010.png'],
    [DEFAULT_PALETTEID, 'background_008.png'], // we want "background_008" to be the default image and "9" as the default enum value
]);

const themeBackgroundImageImageMap = new Map<number, string>([
    [0, 'largeBackground_001.jpg'],
    [1, 'largeBackground_002.jpg'],
    [2, 'largeBackground_003.jpg'],
    [3, 'largeBackground_004.jpg'],
    [4, 'largeBackground_005.jpg'],
    [5, 'largeBackground_006.jpg'],
    [6, 'largeBackground_007.jpg'],
    [7, 'largeBackground_009.jpg'],
    [8, 'largeBackground_010.jpg'],
    [DEFAULT_PALETTEID, 'largeBackground_008.jpg'], // we want "background_008" to be the default image and "9" as the default enum value
]);

export const themeImageEnum = new Map<string, number>([
    ['background_001.png', 0],
    ['background_002.png', 1],
    ['background_003.png', 2],
    ['background_004.png', 3],
    ['background_005.png', 4],
    ['background_006.png', 5],
    ['background_007.png', 6],
    ['background_009.png', 7],
    ['background_010.png', 8],
    ['background_008.png', DEFAULT_PALETTEID], // we want "background_008" to be the default image and "9" as the default enum value
]);

export const getThemeImageAriaLabels = () => {
    return new Map<number, string>([
        [0, loc(themeImageAriaLabel1)],
        [1, loc(themeImageAriaLabel2)],
        [2, loc(themeImageAriaLabel3)],
        [3, loc(themeImageAriaLabel4)],
        [4, loc(themeImageAriaLabel5)],
        [5, loc(themeImageAriaLabel6)],
        [6, loc(themeImageAriaLabel7)],
        [7, loc(themeImageAriaLabel8)],
        [8, loc(themeImageAriaLabel9)],
        [9, loc(themeImageAriaLabel10)],
    ]);
};

export function getSmallThemeImageUrl(imageEnum: number): string {
    const imageRelativePath = themeImageMap.get(imageEnum);
    return `https:${getCdnUrl()}assets/bookwithme/${imageRelativePath}`;
}

export function getLargeThemeImageUrl(imageEnum: number): string {
    const imageRelativePath = themeImageMap.get(imageEnum);
    return `https:${getCdnUrl()}assets/bookwithme/${imageRelativePath}`;
}

export function getFullBackgroundImageUrl(imageEnum: number): string {
    const imageRelativePath = themeBackgroundImageImageMap.get(imageEnum);
    return `https:${getCdnUrl()}assets/bookwithme/fullImages/${imageRelativePath}`;
}

export function getMultiSessionEventImageUrl(): string {
    return `https:${getCdnUrl()}assets/eventify/misc/multi_session_event.png`;
}

export function getBookwithmeLogo(): string {
    return `https:${getCdnUrl()}assets/bookwithme/misc/CalendarPerson20px.png`;
}

export function getThemeImageEnumValue(imageUrl: string): number {
    const parts = imageUrl.split('/');
    const lastSegment = parts.pop();
    let imageEnum = 0;
    if (lastSegment && themeImageEnum.has(lastSegment)) {
        imageEnum = themeImageEnum.get(lastSegment) ?? 0;
    }
    return imageEnum;
}
